import { Component, Input, OnInit } from '@angular/core';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'app-user-detail-destinations-nations',
  templateUrl: './user-detail-destinations-nations.component.html',
  styleUrls: ['./user-detail-destinations-nations.component.css']
})
export class UserDetailDestinationsNationsComponent implements OnInit {

  @Input()
  nations: any[];

  expanded: boolean[];

  constructor() { }

  ngOnInit() {
    this.syncExpanded();
  }

  private syncExpanded(expandLast: boolean = false) {
    this.expanded = [];
    this.nations.forEach((item) => this.expanded.push(false));
    if (expandLast) {
      this.expanded[this.expanded.length - 1] = true;
    }
  }

  addNation() {
    this.nations.push({
      name: '',
      regions: []
    });
    this.syncExpanded(true);
  }

  removeNation(nation: any): void {
    if (!confirm("Vuoi veramente rimuovere tutta la nazione " + nation.name + "?")) return;
    const index = this.nations.indexOf(nation);

    if (index >= 0) {
      this.nations.splice(index, 1);
      this.syncExpanded();
    }
  }
}
